export const HiLocale = {
    page: {
        txtTitle: 'SHIRITORI | मजेदार しらとり गेम के साथ ऑनलाइन जापानी शब्दावली सीखना आसान',
    },
    common: {
        txtLogoAlt: 'Shiritori ट्रेन',
    },
    header: {
        txtLeave: 'गेम छोड़ें',
    },
    dialog: {
        leave: {
            txtTitle: 'क्या आप यह गेम छोड़ना चाहते हैं?',
            btnStay: 'गेम में रहें',
            btnLeave: 'छोड़ें और हार मानें',
        },
    },
    home: {
        btnNewGame: 'नया गेम',
        btnMainMenu: 'मुख्य मेनू',
        btnJoinGame: 'जुड़ें',
        btnReturnToGame: 'गेम पर वापस जाएँ',
    },
    create: {
        headingNamePrompt: 'हम आपको किस नाम से बुलाएँ?',
        placeholderName: 'आपका नाम',
        btnOk: 'ठीक है',
    },
    join: {
        placeholderName: 'आपका नाम',
        placeholderGameId: 'गेम आईडी',
        btnJoinGame: 'जुड़ें',
    },
    configure: {
        header: 'गेम सेटअप',
        labelExpectedPlayers: 'खिलाड़ियों की संख्या',
        labelBoardSize: 'बोर्ड का आकार',
        labelWordList: 'शब्द सूची',
        labelAllowHints: 'संकेतों की अनुमति दें',
        labelTurnTimer: 'टर्न टाइमर',
        optionNoTimer: 'टाइमर नहीं',
        optionTimer: 'टाइमर',
        unitSeconds: 'सेक',
        btnStartGame: 'शुरू करें',
        toastCreateError: 'त्रुटि: यह गेम नहीं बनाया जा सका',
        toastTryAgain: 'त्रुटि: कृपया बाद में फिर प्रयास करें।',
    },
    game: {
        lobby: {
            btnReady: 'तैयार',
            txtShareInvite: 'यह कोड अपने दोस्तों के साथ साझा करें!',
            txtPlayer: 'खिलाड़ी',
            txtTeam: 'टीम',
        },
        message: {
            noSuchGame: 'यह गेम मौजूद नहीं है',
            txtLoading: 'लोड हो रहा है...',
            txtCannotJoin: 'गेम में शामिल नहीं हो सके',
        },
        gameplay: {
            board: {
                timeoutTitle: 'समय',
                timeoutSubtitle: 'समाप्त',
            },
            wordSearch: {
                multipleMatches: 'कई मेल मिले!',
                yourTurn: 'आपकी बारी',
                placeholder: 'हम कौन-सा शब्द खेलें?',
                playAction: 'खेलें',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'ऐसा कोई शब्द नहीं!',
                toastCantPlay: 'यह शब्द नहीं खेल सकते!',
                toastPlayed: '"{{word}}" खेला गया',
                toastPlayFailed: 'ओह, यह शब्द नहीं खेल पाए!',
                validation: {
                    syllableMismatch: 'शुरुआती अक्षरांश मेल नहीं खाता',
                    missingLastWord: 'पिछली बारी में कोई शब्द नहीं है',
                    wordNotInList: 'शब्द चुनी गई सूची में नहीं है',
                }
            },
            spectate: {
                waitingOn: '{{player}} का इंतज़ार',
                timeLeft: 'बचा समय: {{seconds}}s',
            },
            endGame: {
                header: 'गेम समाप्त',
                viewResults: 'परिणाम देखें',
                statsTotalTime: 'कुल खेल समय',
                statsSquaresFilled: 'भरे गए खाने',
                statsLongestWord: 'सबसे लंबा शब्द',
                share: 'साझा करें',
                sharing: 'साझा किया जा रहा है...',
                ariaCloseLabel: 'गेम समाप्ति मोडल बंद करें',
            }
        },
    },
    footer: {
        linkHowToPlay: 'कैसे खेलें',
        linkPrivacyPolicy: 'गोपनीयता नीति',
        txtAllRightsReserved: 'सर्वाधिकार सुरक्षित।',
    },
    howToPlay: {
        title: 'Shiritori しりとり (shiritori) कैसे खेलें',
        btnPlayNow: 'अभी खेलें!',
        btnReturnToGame: 'गेम पर वापस जाएँ:',
        description1: 'b|Shiritori| जापानी शब्द-श्रृंखला खेल しりとり का हमारा ऑनलाइन मल्टीप्लेयर रूप है। दोस्तों के साथ या अकेले शब्दावली का अभ्यास करते हुए चित्रों वाला बोर्ड बनाइए।',
        description2: 'गेम बनाएँ या जॉइन करें, बोर्ड आकार, चित्र सेट और शब्द सूची चुनें, फिर किसी की गलती से पहले मान्य शब्दों से ग्रिड भरने की दौड़ लगाएँ।',
        gameSetup: {
            title: 'गेम बनाएँ या जॉइन करें',
            p1: 'आप अकेले शुरू कर सकते हैं या साझा लिंक/गेम कोड से अधिकतम 9 दोस्तों (कुल 10 खिलाड़ी) को आमंत्रित कर सकते हैं।',
            p2: 'अपनी पसंद के विकल्प चुनें: बोर्ड आकार (3x3, 5x5, 7x7), बैकग्राउंड पैटर्न/रंग, चित्र सेट और पढ़ाई के लिए शब्द सूची।',
            p3: 'दोस्त लिंक खोलते हैं, निकनेम चुनते हैं और लॉबी में दिखते हैं; अपेक्षित खिलाड़ी जुड़ते ही गेम शुरू हो जाता है।',
            p4: 'देर से आने वाले खिलाड़ी भी चल रहे मैच को केवल देखने वाले मोड में देख सकते हैं।',
        },
        objective: {
            title: 'उद्देश्य',
            p1: 'शब्दों को इस तरह जोड़ें कि हर नया शब्द पिछले शब्द के अंतिम अक्षरांश से शुरू हो, बोर्ड भरें, और किसी भी शब्द का अंत ん से न करें।',
        },
        wordRules: {
            title: 'मान्य शब्द',
            p1: 'काना या रोमाजी में लिखें; जांच से पहले रोमाजी को क्लाइंट-साइड पर हिरागाना में बदला जाता है।',
            p2: 'शब्द चुनी गई सूची में होने चाहिए (100/1000 सामान्य, भोजन, खेल आदि) और खेलने के बाद उनका अर्थ दिखता है।',
            p3: 'पहले खेले गए शब्द ब्लॉक हो जाते हैं। यदि समान उच्चारण वाले शब्द (homophones) अनुमति हों, तो सही चित्र के साथ अनउपयोगित रूप चुन सकते हैं।',
            li1: 'पिछली बारी के आवश्यक अक्षरांश से शुरू हो',
            li2: 'अंत ん (n) से न हो',
            li3: 'चुनी गई शब्द सूची में शामिल हो',
            li4: 'इस गेम में पहले न खेला गया हो',
            li5: 'जब नियम सक्षम हो तो मान्य homophone/चित्र का उपयोग करे',
            p4: 'हर मान्य चाल अपनी तस्वीर को क्रम से बोर्ड में डालती है, और ग्रिड बाएँ से दाएँ, ऊपर से नीचे भरता है। e|उदाहरण:_そば_→_バス|',
        },
        turnFlow: {
            title: 'टर्न और समय',
            p1: 'टर्न खिलाड़ियों की सूची में क्रम से चलते हैं; आपकी बारी दिखते ही आपको अधिकतम 10 सेकंड मिलते हैं।',
            p2: 'Shiritori अगले खिलाड़ी के सक्रिय होने (ब्राउज़र फोकस में) तक काउंटडाउन शुरू नहीं करता, जिससे रीस्टार्ट/रीलोड करके टाइमर को स्किप नहीं किया जा सकता।',
            p3: 'अपना शब्द दर्ज करें, लाइव वैलिडेशन देखें, और समय सीमा से पहले सबमिट करें। अमान्य या देर से सबमिशन मैच तुरंत समाप्त कर देता है।',
        },
        boardFlow: {
            title: 'बोर्ड, प्रवाह और समाप्ति',
            p1: 'बोर्ड हर खेले गए शब्द को उसकी तस्वीर, खिलाड़ी नाम और टर्न नंबर के साथ दिखाता है, और तीर ग्रिड में क्रम दिखाते हैं।',
            p2: 'जब किसी और की बारी हो, तब भी आप आवश्यक शुरुआती अक्षरांश और काउंटडाउन देख सकते हैं।',
            p3: 'यदि सभी खाने मान्य शब्दों से भर जाते हैं, तो गेम सफलता के साथ समाप्त होता है और साझा करने के लिए पूरा बोर्ड दिखाता है।',
            p4: 'यदि टाइमर खत्म होने से पहले कोई मान्य चाल नहीं आती, तो गेम इस सारांश के साथ खत्म होता है कि कौन टाइम आउट हुआ या अमान्य शब्द खेला।',
        },
        summary: {
            title: 'सारांश',
            p1: 'Shiritori शिरितोरी को तेज और दृश्यात्मक रखता है: छोटे राउंड, स्पष्ट नियम और चित्र-आधारित याददाश्त से सबकी श्रृंखला चलती रहती है।',
            p2: 'लिंक साझा करें, बोर्ड भरें और देखें आपकी शब्द-श्रृंखला कितनी दूर जा सकती है।',
        }
    },
    bugsAndFeatures: {
        title: 'बग रिपोर्ट और नए फीचर',
        p1: 'हमने इस गेम को क्लासिक k|しりとり.| खेलने के एक अलग तरीके के रूप में बनाया है। गेम प्रेमी टीम होने के नाते हम इसे बेहतर और अधिक मजेदार बनाने के तरीके हमेशा खोजते रहते हैं।',
        cta: {
            l1: 'दरअसल, हमें खुशी होगी यदि आप ',
            a: 'हमारा गेम अपने दोस्तों के साथ साझा करें',
            l2: ' सोशल मीडिया पर!'
        },
        p2: 'यदि आपको कोई बग मिले या नए फीचर के सुझाव हों, तो हमें जरूर बताइए!',
        bugs: {
            title: 'बग',
            p1: 'कोई भी अजीब व्यवहार, त्रुटि या बग हमारे सार्वजनिक a|https://github.com/indexinteractive/|GitHub_रिपॉजिटरी| पर सीधे रिपोर्ट करें। कृपया अधिक से अधिक विवरण दें, खासकर बग दोहराने के चरण।'
        },
        features: {
            title: 'नए फीचर',
            p1: 'यदि आपके पास नए फीचर, सुधार या गेम के लिए विचार हों, तो हमारी a|https://github.com/indexinteractive/|GitHub_Discussions| पेज पर नई चर्चा बनाकर हमें बताइए।'
        }
    },
    share: {
        title: 'Shiritori | मजेदार しらとり गेम के साथ ऑनलाइन जापानी शब्दावली सीखना आसान - SHIRITORI',
        text: 'दोस्तों या रैंडम खिलाड़ियों के साथ ऑनलाइन Shiritori खेलें। साइन-अप की जरूरत नहीं!',
    }
};
